import React, { useContext, useState, useEffect } from 'react';
import { Menu, Space, Dropdown, Modal, Form, Input, Button, message } from 'antd';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { useHeader } from './HeaderContext';
import AuthContext from '../context/AuthProvider';
import axios from 'axios';
import useChangePassword from '../hooks/useChangePassword.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { useAlert } from '../components/AlertContext.jsx';

const { SubMenu } = Menu;

const PageHeader = ({ header, username, onChangePassword, onLogout }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [modalVisible, setModalVisible] = useState(false);
    const { auth } = useContext(AuthContext);
    const Utilizador = auth.user ? auth.user : "nodejs";

    const { triggerAlert } = useAlert();
    const { changePassword } = useChangePassword();

    const handleSavePassword = async (values) => {
        let response = await changePassword(auth.user || "nodejs", values);
        let message = response.message;
        triggerAlert(message, 'warning');
    };

    const items = [
        {
            label: "Change Password",
            key: '0'
        },
        {
            label: "Logout",
            key: '1'
        },
    ];

    const onClick = ({ key }) => {
        if (key === "0") {
            setModalVisible(true);
        }
        if (key === "1") {
            onLogout();
        }
    };

    return (
        <div id="page_header" className="p-2 d-flex justify-content-between app_font_header border m-0" style={{ backgroundColor: '#2E7DBF', color: 'white', width: '100%', height: '38px' }}>
            <h6 style={{ margin: '0' }}>{header}</h6>
            <div style={{ cursor: 'pointer' }}>
                <Dropdown menu={{ items, onClick }} trigger={['click']}>
                    <Space>
                        <span>{username}</span>
                        <FontAwesomeIcon icon={faUser} className="mr-2" style={{ marginBottom: '2px' }} />
                    </Space>
                </Dropdown>
            </div>
            <ChangePasswordModal
                visible={modalVisible}
                onClose={() => setModalVisible(false)}
                onSave={handleSavePassword}
            />
        </div>
    );
};

const MainLayout = () => {
    const { header } = useHeader();
    const { auth, setAuth } = useContext(AuthContext);
    const version = "0.2.1 - 20/03/2025";
    const navigate = useNavigate();
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const Utilizador = auth.user ? auth.user : "nodejs";
    const [menuItems, setMenuItems] = useState([]);
    const [erroLogin, setErroLogin] = useState(null);

    useEffect(() => {
        const fetchMenuItems = async () => {
            try {
                console.log("MainLayout.js > useEffect > auth: ", auth);

                console.log("MainLayout.js > useEffect > auth.group_id ", auth.group_id);
                const response = await axios.get(`${baseURL}/group_menu_permissions/` + auth.group_id, {

                    withCredentials: true
                });
                setMenuItems(response.data);

                console.log("response.data: ", response.data)
            } catch (err) {
                console.error("Failed to fetch menu items", err);
            }
        };
        fetchMenuItems();
    }, [baseURL, auth.user]);

    const handleLogout = async () => {
        try {
            await axios.get(`${baseURL}/logout`, { withCredentials: true });
            setAuth({
                isAuthenticated: false,
                user: null,
                user_id: null,
                group_id: null,
                group_name: null,
                permissions: [],
            });
            // Clear all items from sessionStorage
            sessionStorage.clear();

        } catch (err) {
            if (!err?.response) {
                setErroLogin("Sem resposta do servidor");
            } else if (err.response?.status === 400) {
                setErroLogin("Sem utilizador ou password");
            } else if (err.response?.status === 401) {
                setErroLogin("Não autorizado");
            } else {
                setErroLogin("Login falhou");
            }
        }
    };

    const renderMenu = (items, parent_key = null) => {
        return items.filter(item => item.parent_key === parent_key).map(item => {
            const children = renderMenu(items, item.menu_key);

            if (children.length) {
                return (
                    <SubMenu key={item.menu_key} title={item.description}>
                        {children}
                    </SubMenu>
                );
            }

            return (
                <Menu.Item key={item.menu_key}>
                    <Link to={item.url}>{item.description}</Link>
                </Menu.Item>
            );
        });
    };

    const handleChangePassword = () => {
        navigate('/change-password');
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-auto col-md-0 col-xl-0 px-sm-0 px-0" style={{ width: '224px', position: 'fixed', height: '100%', overflowY: 'auto' }}>
                    <div className="d-flex flex-column align-items-center align-items-sm-start px-2 pt-2 text-black min-vh-100 menu-vert-bar app_font1">
                        <div className="text-center py-0 d-flex flex-column align-items-center" style={{ width: '100%', color: 'white', bgcolor: '#527898' }}>
                            {/*    <img src={`${process.env.PUBLIC_URL}/images/app_logo.png`} alt="Logo" style={{ width: '100px' }} />   */}
                            <img src={`${process.env.PUBLIC_URL}/images/app_logo2.png`} alt="Second Logo" style={{ width: '180px', marginTop: '10px', marginBottom: '10px' }} />
                        </div>
                        <Menu mode="inline" style={{ width: 200 }} className="custom-menu no-underline" theme="light">
                            {renderMenu(menuItems)}
                            <Menu.Item key="logout" onClick={handleLogout} style={{ marginTop: '15px' }}>
                                Logout
                            </Menu.Item>
                        </Menu>
                        {/* Wrap the image and version divs in a container */}
                        <div className="mt-auto w-100">
                            <div className="text-center w-100 py-2">
                                <a target="_blank" href="https://www.impetus.pt"> <img src={`${process.env.PUBLIC_URL}/images/logo_impetus.svg`} alt="Logo" style={{ width: '100px', marginBottom: '10px' }} /></a>
                            </div>
                            <div className="text-center w-100 py-2" style={{ color: '#D0D4DB' }}>
                                <small>version {version}</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col ml-4">
                    <div className="col p-0 m-0">
                        <div style={{ marginLeft: '212px' }}>
                            <PageHeader header={header} username={auth.user} onChangePassword={handleChangePassword} onLogout={handleLogout} />
                        </div>
                        <div style={{ marginLeft: '220px' }}>
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const ChangePasswordModal = ({ visible, onClose, onSave }) => {
    const [form] = Form.useForm();

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            onSave(values);
        } catch (error) {
            console.log('Validation Failed:', error);
        }
    };

    return (
        <Modal
            visible={visible}
            title="Alterar Password"
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Cancelar
                </Button>,
                <Button key="submit" type="primary" onClick={handleSubmit}>
                    Gravar
                </Button>,
            ]}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="currentPassword"
                    label="Password Atual"
                    rules={[{ required: true, message: 'Colocar a password atual!' }]}
                >
                    <Input.Password />
                </Form.Item>
                <Form.Item
                    name="newPassword"
                    label="Nova Password"
                    rules={[{ required: true, message: 'Colocar a nova password!' }]}
                >
                    <Input.Password />
                </Form.Item>
                <Form.Item
                    name="confirmNewPassword"
                    label="Confirmar Nova Password"
                    dependencies={['newPassword']}
                    rules={[
                        { required: true, message: 'Confirmar a nova password!' },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('newPassword') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('As duas password não coincidem!'));
                            },
                        }),
                    ]}
                >
                    <Input.Password />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default MainLayout;
